import { useCallback, useRef, useState } from 'react';
export const useVideoPlayerControls = () => {
    const [fullscreen, setFullscreen] = useState(false);
    const videoPlayerRef = useRef(null);
    const play = useCallback(() => {
        var _a;
        (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.play().catch((error) => {
            // eslint-disable-next-line no-console
            console.error('useVideoPlayerControls: play failed due to', error);
        });
    }, []);
    const pause = useCallback(() => {
        var _a;
        (_a = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.pause();
    }, []);
    const togglePlaying = useCallback(() => {
        var _a, _b, _c;
        if ((_a = videoPlayerRef.current) === null || _a === void 0 ? void 0 : _a.paused) {
            (_b = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _b === void 0 ? void 0 : _b.play().catch((error) => {
                // eslint-disable-next-line no-console
                console.error('useVideoPlayerControls: play failed due to', error);
            });
        }
        else {
            (_c = videoPlayerRef === null || videoPlayerRef === void 0 ? void 0 : videoPlayerRef.current) === null || _c === void 0 ? void 0 : _c.pause();
        }
    }, []);
    const controls = {
        videoPlayerRef,
        play,
        pause,
        togglePlaying,
        fullscreen,
        setFullscreen,
    };
    /**
     * We export them twice so in the examples we can destruct `controls` to be passed down to the `video` component.
     * This avoids having to use `controls.play()` for example.
     */
    return { controls, ...controls };
};
